import { render, staticRenderFns } from "./Exchangdea.vue?vue&type=template&id=37ca6bef&scoped=true"
import script from "./Exchangdea.vue?vue&type=script&lang=js"
export * from "./Exchangdea.vue?vue&type=script&lang=js"
import style0 from "./Exchangdea.vue?vue&type=style&index=0&id=37ca6bef&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca6bef",
  null
  
)

export default component.exports